import { abyssColors } from '@/theme/colors';

type Confidence = {
  value: 'High' | 'Medium' | 'Low';
  color: string;
};

export const getDistanceConfidence = (distance: number): Confidence => {
  return distance <= 5
    ? { value: 'High', color: abyssColors.success[600] }
    : distance <= 7
      ? { value: 'Medium', color: abyssColors.warning[600] }
      : { value: 'Low', color: abyssColors.error[600] };
};

export const getAngleConfidence = (angle: number): Confidence => {
  return angle <= 60
    ? { value: 'High', color: abyssColors.success[600] }
    : angle <= 75
      ? { value: 'Medium', color: abyssColors.warning[600] }
      : { value: 'Low', color: abyssColors.error[600] };
};

export const getPipeSizeConfidence = (pipeSize: number): Confidence => {
  return pipeSize > 3
    ? { value: 'High', color: abyssColors.success[600] }
    : pipeSize >= 2
      ? { value: 'Medium', color: abyssColors.warning[600] }
      : { value: 'Low', color: abyssColors.error[600] };
};

export const calculateConfidence = (distance: number, pipeSize?: number, angle?: number) => {
  const distanceConfidence = getDistanceConfidence(distance).value;
  const angleConfidence = angle ? getAngleConfidence(angle).value : undefined;
  const pipeSizeConfidence = pipeSize ? getPipeSizeConfidence(pipeSize).value : undefined;

  // Angle and pipeSize are optional in the confidence calculation. If either is undefined, the confidence will be calculated without it.
  const confidences = new Set(
    [distanceConfidence, angleConfidence, pipeSizeConfidence].filter(Boolean)
  );

  if (confidences.has('Low')) return 'Low';
  if (confidences.has('Medium')) return 'Medium';
  return 'High';
};
